module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "main"
    }
  }, [_c('navatras-app', {
    attrs: {
      "linksPath": _vm.linksPath
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "focus",
      rawName: "v-focus"
    }],
    staticClass: "offscreen",
    attrs: {
      "id": "content-label",
      "tabindex": "0",
      "alt": "Contenido. Se sugiere navegar con las flechas del teclado."
    }
  }), _vm._v(" "), _c('davivienda' + _vm.$route.params.unipage + '-app', {
    tag: "component"
  }), _vm._v(" "), _c('navadel-app', {
    attrs: {
      "linksPath": _vm.linksPath
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-464214c2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/screens/00-davivienda/davivienda.vue
// module id = 969
// module chunks = 1